import styled, { css } from 'styled-components';
import { GridWrapperStyled } from '~/components/organisms/grid/styled';

export const CustomGridWrapperStyled = styled(GridWrapperStyled)`
  ${({ theme }) => css`
    .ag-row-selected .ag-cell {
      background-color: ${theme.colors.primary[300]} !important;
    }
    .ag-row-hover .ag-cell {
      background-color: ${theme.colors.primary[300]} !important;
    }
  `};
`;
